import { GPCComp } from 'api';
import { CapIQCompanyData, CapIQPublicCompsList } from 'pages/ValuationsAllocation/types';

type CheckCompExistsInTableProps = {
  existingComps: GPCComp[];
  publicCompsData: CapIQPublicCompsList;
};

const checkCompExistsInTable = ({ existingComps, publicCompsData }: CheckCompExistsInTableProps): CapIQCompanyData[] | undefined => {
  const currentCompsIds = existingComps?.map(comp => comp.cap_iq_id) || [];

  return publicCompsData.results?.map(company => {
    const capIqId = company.cap_iq_id?.value ?? '';
    const companyAlreadyInTable = currentCompsIds.includes(capIqId.toString());
    return {
      gpc: companyAlreadyInTable
        ? {
          company_name: {
            value: `"${company.ticker_symbol?.value}" already present in the table`,
          },
          ticker_symbol: {
            value: company.ticker_symbol?.value ?? '',
          },
        }
        : company,
      notFound: false,
      valid_gpc_results: !companyAlreadyInTable,
      requested_identifier: String(company.ticker_symbol?.value ?? ''),
    };
  });
};

export default checkCompExistsInTable;
